import { useEffect, useState } from "react";
import { useCalls } from "@usedapp/core";
import { Contract } from "@ethersproject/contracts";
import AirdropDistributor from "@/chain-info/contracts/AirdropDistributor.json";
import NFTAirdropDistributor from "@/chain-info/contracts/NFTAirdropDistributor.json";
import { constants, utils } from "ethers";

const useCampaignInfo = (
  campaignType: string,
  addresses: string[] | null | undefined,
  chainId: number | undefined
) => {
  const [error, setError] = useState<string | undefined>();
  const [campaignInfo, setCampaignInfo] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  // const [resultsTest, setResultsTest] = useState<any[]>([]);
  // const [resultsTest2, setResultsTest2] = useState<any[]>([]);
  const { abi: airdropDistributorAbi } = AirdropDistributor;
  const { abi: nftAirdropDistributorAbi } = NFTAirdropDistributor;
  const abi =
    campaignType === "TOKEN" ? airdropDistributorAbi : nftAirdropDistributorAbi;
  const contractInterface = new utils.Interface(abi);
  const airdropDistributorContract = addresses?.map((address) => {
    return new Contract(address ?? constants.AddressZero, contractInterface);
  });

  const tokenQueries = [
    "name",
    "owner",
    "reach",
    "token",
    "merkleRoot",
    "isActive",
    "frozenInfoURI",
    "baseInfoURI",
    "claimedNum",
  ];

  const nftQueries = [
    "name",
    "owner",
    "reach",
    "maxSupply",
    "merkleRoot",
    "isActive",
    "frozenInfoURI",
    "baseInfoURI",
    "claimedNum",
  ];
  // console.log("address", addresses);
  const queries = campaignType === "TOKEN" ? tokenQueries : nftQueries;
  const calls =
    addresses?.map(
      (address, idx) =>
        queries?.map(
          (query) =>
            address && {
              contract: airdropDistributorContract![idx],
              method: query,
              args: [],
            }
        ) ?? []
    ) ?? [];
  // console.log("id here ",chainId);
  // const results = useCalls(calls.flat()) ?? []; //FIXME chainId won't trigger useCalls update
  const results =
    // @ts-ignore
    useCalls(calls[0] !== undefined ? calls?.flat() : [], {
      chainId: chainId,
    }) ?? [];
  // console.log('results:',results);
  // const results = useCalls(calls.flat(), { isStatic: true }) ?? [];
  // console.log('results:', results);
  // console.log('results:', chainId, typeof chainId, calls, results);

  const groupByN = (n: number, data: any[]) => {
    let result = [];

    for (let i = 0; i < data.length; i += n) {
      if (data[i] !== undefined) {
        result.push(data?.slice(i, i + n));
      } else {
        continue;
      }
    }
    return result;
  };
  useEffect(() => {
    // console.log('HERE1', loading);
    setLoading(true);
    let areAllNotUndefined = results?.every((i) => {
      return i !== undefined;
    });
    if (areAllNotUndefined) {
      const campaignResults = groupByN(
        queries.length,
        results.map((result) => result?.value)
      );
      // console.log('campaignResults:', campaignResults);
      const data = campaignResults?.map((campaignResult, i) => {
        const obj = {} as any;
        queries?.map((query, index) => (obj[query] = campaignResult[index][0]));
        obj["address"] = addresses![i];
        obj["type"] = campaignType;
        obj["chainId"] = chainId;
        return obj;
      });
      setCampaignInfo(data);
      setLoading(false);
    }
    // console.log('HERE2', loading);

    results.forEach((result, idx) => {
      if (result && result.error) {
        const err = `Error encountered calling '${queries[idx]}' on ${
          addresses![idx]
        }: ${result.error.message}`;
        setError(err);
        console.error(err);
        setLoading(false);
      }
    });
    // console.log('HERE3', loading);

    // eslint-disable-next-line
  }, [results, chainId]);
  // useEffect(() => {
  //   console.log('HERE4', loading);
  // }, [loading]);
  // FIXME 0608 When you switch from another chain to the campaign chain, it will forever load. Temp workaround so far

  return { campaignInfo, error, loading };
};

export default useCampaignInfo;
